import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=1b179a1c&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b179a1c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b179a1c')) {
      api.createRecord('1b179a1c', component.options)
    } else {
      api.reload('1b179a1c', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=1b179a1c&scoped=true&", function () {
      api.rerender('1b179a1c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2CINoTXJh4Uly/JS/comp/Accordion.vue"
export default component.exports